var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5244_36486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3984 0.234375L9.43281 5.2H12.3984V6.4H6.39844C4.85625 6.4 3.59844 7.65781 3.59844 9.2V14.8H0.632812L5.59844 19.7656L10.5641 14.8H7.59844V13.6H13.5984C15.1406 13.6 16.3984 12.3422 16.3984 10.8V5.2H19.3641L14.3984 0.234375ZM14.3984 1.36563L17.4328 4.4H15.5984V10.8C15.5984 11.9094 14.7078 12.8 13.5984 12.8H7.59844V10.4H13.1984V4.4H11.3641L14.3984 1.36563ZM6.39844 7.2H12.3984V9.6H6.79844V15.6H8.63281L5.59844 18.6344L2.56406 15.6H4.39844V9.2C4.39844 8.09063 5.28906 7.2 6.39844 7.2Z",
    fill: "#929292"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5244_36486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/ChangeIcon.45334195fec5f433d183eff06c38c40d.svg";
export { ForwardRef as ReactComponent };